export default __webpack_public_path__ + "static/media/bg-balao-01.762a05aa.png";